import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'normalize.css/normalize.css'
import './commons/scss/index.scss';
// import './commons/scss/login.scss'
import App from './components/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'url-search-params-polyfill'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);